import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

export function NavTabItem({ to, label, count, ...props }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `inline-flex items-center pt-1 space-x-2 border-b-2 text-sm font-light h-10${
          isActive
            ? ' border-primary-500 text-primary-500'
            : ' border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
        }`
      }
      {...props}
    >
      <span>{label}</span>
      {count ? <span className="badge badge-gray">{count}</span> : null}
    </NavLink>
  );
}

NavTabItem.defaultProps = {
  count: '',
};

NavTabItem.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  count: PropTypes.string,
};

function NavTab({ children }) {
  return (
    <div className="bg-white">
      <div className="container px-1 flex items-center space-x-2 lg:space-x-10">
        {children}
      </div>
    </div>
  );
}

NavTab.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default NavTab;
